import Backbone from '@polleverywhere/backbone'
import Vote from './vote'

// @namespace Model
export default class DiscourseVotes extends Backbone.Collection {
  get model () {
    return Vote
  }

  /**
   * Discourse vote is a singleton resource. For every result, there is only one
   * vote model associated with it. Make the collection aware of this and
   * prevent two vote models with the same `result_id` from existing.
   */
  modelId (attrs) {
    return attrs.result_id
  }

  initialize (models = [], options = {}) {
    // Track parent
    this.poll = options.poll
  }

  fetch () {
    console.log('DiscourseVotes#fetch : not implemented')
  }
}
